import { roundToUp } from "round-to"
import { countOfOrdersToDate, sumTotalAllCustomer, sumTotalValue, sumValueOfOrdersToDate } from "../../../utils/helper"
import { formatNumber } from "../../../utils/number"

export const newCustomerCountKPI = (currentCustomers, lastMonthCustomers) => {
    const currentCount = currentCustomers?.length || 0
    const lastMonthCount = lastMonthCustomers?.length || 0

    let result = {
        caption: 'Novos Clientes',
        metric: currentCount,
        badgeDelta: 0,
        deltaType: 'unchanged',
        progress: 0,
        target: `Mês anterior: ${lastMonthCount}`
    }

    if (lastMonthCount > 0) {
        const delta = ((currentCount - lastMonthCount) / lastMonthCount) * 100
        result.badgeDelta = roundToUp(delta, 2)

        result.progress = roundToUp((currentCount / lastMonthCount) * 100, 2)

        if (delta > 0) {
            result.deltaType = 'moderateIncrease'
        } else if (delta < 0) {
            result.deltaType = 'moderateDecrease'
        }
    } else if (currentCount > 0) {
        result.badgeDelta = 100
        result.deltaType = 'moderateIncrease'
        result.progress = 100
    }

    return result
}

export const totalValueNewCustomers = (currentMonthNewCustomersSales, lastMonthSalesNewCustomers) => {
    let result = {
        caption: 'Valor dos Novos Clientes',
        metric: 0,
        badgeDelta: 0,
        progress: 0,
        target: 0,
        deltaType: 'moderateIncrease',
    }

    if (!currentMonthNewCustomersSales || currentMonthNewCustomersSales.length === 0) {
        return result
    }

    const currentMonthCustomer = sumTotalAllCustomer(currentMonthNewCustomersSales)
    const currentMonthValue = sumTotalValue(currentMonthNewCustomersSales)

    if (currentMonthCustomer === 0) {
        return result
    }

    const currentMetric = currentMonthValue / currentMonthCustomer
    result.metric = formatNumber(roundToUp(currentMonthValue, 2), { style: 'currency' })

    if (lastMonthSalesNewCustomers?.length > 0) {
        const lastMonthValue = sumTotalValue(lastMonthSalesNewCustomers)

        result.target = "Mês anterior: " + formatNumber(roundToUp(lastMonthValue, 2), { style: 'currency' })
        result.badgeDelta = roundToUp(((currentMetric - lastMonthValue) / lastMonthValue) * 100, 2)
        result.progress = roundToUp((currentMetric / lastMonthValue) * 100, 2)
    }

    if (lastMonthSalesNewCustomers?.length > 0) {
        const currentDay = new Date().getDate()

        const salesByTodayValue = sumValueOfOrdersToDate(lastMonthSalesNewCustomers, currentDay)
        const salesByTodayLength = countOfOrdersToDate(lastMonthSalesNewCustomers, currentDay)

        if (salesByTodayValue > 0 && salesByTodayLength > 0) {
            const salesByTodayTarget = salesByTodayValue / salesByTodayLength

            result.badgeDelta = roundToUp(((currentMetric - salesByTodayTarget) / salesByTodayTarget) * 100, 2)
            result.progress = roundToUp((currentMetric / salesByTodayTarget) * 100, 2)
        }
    }

    return result
}

export const orderAverageNewCustomerKPI = (currentMonthNewCustomersSales, lastMonthSalesNewCustomers, selectedDate = new Date()) => {
    let result = {
        caption: 'Ticket Médio dos Novos Clientes',
        metric: 0,
        badgeDelta: 0,
        progress: 0,
        target: 0,
        deltaType: 'moderateIncrease',
    }

    if (!currentMonthNewCustomersSales || currentMonthNewCustomersSales.length === 0) {
        return result
    }

    const currentMonthCustomer = sumTotalAllCustomer(currentMonthNewCustomersSales)
    const currentMonthValue = sumTotalValue(currentMonthNewCustomersSales)

    if (currentMonthCustomer === 0) {
        return result
    }

    const currentMetric = currentMonthValue / currentMonthCustomer

    result.metric = formatNumber(roundToUp(currentMetric, 2), { style: 'currency' })

    if (lastMonthSalesNewCustomers?.length > 0) {
        const lastMonthCustomer = sumTotalAllCustomer(lastMonthSalesNewCustomers)
        const lastMonthValue = sumTotalValue(lastMonthSalesNewCustomers)

        if (lastMonthCustomer > 0) {
            const currentTarget = lastMonthValue / lastMonthCustomer

            result.target = "Mês anterior: " + formatNumber(roundToUp(currentTarget, 2), { style: 'currency' })
            result.badgeDelta = roundToUp(((currentMetric - currentTarget) / currentTarget) * 100, 2)
            result.progress = roundToUp((currentMetric / currentTarget) * 100, 2)
        }
    }

    if (lastMonthSalesNewCustomers?.length > 0) {
        const currentDay = selectedDate.getDate()
        const salesByTodayValue = sumValueOfOrdersToDate(lastMonthSalesNewCustomers, currentDay)
        const salesByTodayLength = countOfOrdersToDate(lastMonthSalesNewCustomers, currentDay)

        if (salesByTodayValue > 0 && salesByTodayLength > 0) {
            const salesByTodayTarget = salesByTodayValue / salesByTodayLength

            result.badgeDelta = roundToUp(((currentMetric - salesByTodayTarget) / salesByTodayTarget) * 100, 2)
            result.progress = roundToUp((currentMetric / salesByTodayTarget) * 100, 2)
        }
    }

    return result
}

export const orderAverageAllCustomerKPI = (currentMonthSalesCustomer, lastMonthSales, selectedDate = new Date()) => {
    let result = {
        caption: 'Ticket Médio de Todos os Clientes',
        metric: 0,
        badgeDelta: 0,
        progress: 0,
        target: 0,
        deltaType: 'moderateIncrease',
    }

    if (!currentMonthSalesCustomer || currentMonthSalesCustomer.length === 0) {
        return result
    }

    const currentMonthCustomer = sumTotalAllCustomer(currentMonthSalesCustomer)
    const currentMonthValue = sumTotalValue(currentMonthSalesCustomer)

    if (currentMonthCustomer === 0) {
        return result
    }

    const currentMetric = currentMonthValue / currentMonthCustomer

    result.metric = formatNumber(roundToUp(currentMetric, 2), { style: 'currency' })

    if (lastMonthSales?.length > 0) {
        const lastMonthCustomer = sumTotalAllCustomer(lastMonthSales)
        const lastMonthValue = sumTotalValue(lastMonthSales)

        if (lastMonthCustomer > 0) {
            const currentTarget = lastMonthValue / lastMonthCustomer

            result.target = "Mês anterior: " + formatNumber(roundToUp(currentTarget, 2), { style: 'currency' })
            result.badgeDelta = roundToUp(((currentMetric - currentTarget) / currentTarget) * 100, 2)
            result.progress = roundToUp((currentMetric / currentTarget) * 100, 2)
        }
    }

    if (lastMonthSales?.length > 0) {
        const currentDay = selectedDate.getDate()
        const salesByTodayValue = sumValueOfOrdersToDate(lastMonthSales, currentDay)
        const salesByTodayLength = countOfOrdersToDate(lastMonthSales, currentDay)

        if (salesByTodayValue > 0 && salesByTodayLength > 0) {
            const salesByTodayTarget = salesByTodayValue / salesByTodayLength

            result.badgeDelta = roundToUp(((currentMetric - salesByTodayTarget) / salesByTodayTarget) * 100, 2)
            result.progress = roundToUp((currentMetric / salesByTodayTarget) * 100, 2)
        }
    }

    return result
}